import React from "react"
import {
  getSingleImage,
  getTitle,
  getSpotifyUrl,
  getAppleUrl
} from "../../helpers/Publications"
import Title from "../Text/Title"

import "./Header.scss"
import { imageUrl } from "../../helpers/ImageUrl"
import BtnExternal from "../Buttons/BtnExternal"

const PodcastHeader = props => {
  const spotifyUrl = getSpotifyUrl(props?.spotify_url)
  const appleUrl = getAppleUrl(props?.apple_url);
  return (
    <header className="podcast__header">
      <div className="podcast__header-visual">
        <img
          src={imageUrl(getSingleImage(props.image), 300, 300)}
          alt={getTitle(props.title)}
          className="podcast__header-image"
        />
      </div>
      <div className="podcast__header-content">
        <p className="podcast__header-label">Podcast</p>
        <Title>{getTitle(props.title)}</Title>
        {props?.showEpisodes &&
          <p className="podcast__header-count">
            {props.podcasts.length}{" "}
            {props.podcasts.length === 1 ? "aflevering" : "afleveringen"}
          </p>
        }
        <div className="podcast__header-buttons">
          {spotifyUrl &&
            <BtnExternal href={spotifyUrl} variant="spotify">
              Naar <strong>Spotify</strong>
            </BtnExternal>
          }
          {appleUrl &&
            <BtnExternal
              href={appleUrl}
              variant="apple-podcasts"
            >
              Naar <strong>Apple Podcasts</strong>
            </BtnExternal>
          }
        </div>
        {props.layout.items.map((item, i) => (
          <p className="podcast__header-intro" key={`intro-${i}`}>
            {item.body}
          </p>
        ))}
      </div>
    </header>
  )
}

export default PodcastHeader
